import React from 'react';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';

class ScoreList extends React.Component {
  loadScoreList = () => {
    let afterUser = false;
    const scoreList = this.props.scoreList.map((item) => {
      if (this.props.userId === item.id) {
        afterUser = true;
        return (
          <tr key={item.id} className="user-score-row mr-0 pr-0 ">
            <th scope="row" className="pr-0 pl-1 row-number">
              {item.position}
            </th>
            <td className="column-name">
              {item.avatar === '' ? (
                <i className="icon-profile avatar mr-3" />
              ) : (
                <img
                  alt=""
                  src={item.avatar}
                  className="mr-3 icon-profile avatar"
                  height="118"
                  width="118"
                />
              )}

              <span>You</span>
            </td>
            <td className="border-right-5 pr-1 text-right column-score cortar">
              +{item.score}pts
            </td>
          </tr>
        );
      }
      if (afterUser) {
        afterUser = false;
        return (
          <tr key={item.id} className="after-user-row">
            <th scope="row" className="pr-0 pl-1 row-number">
              {item.position}
            </th>
            <td className="column-name">
              {item.avatar === '' ? (
                <i className="icon-profile avatar mr-3" />
              ) : (
                <img
                  alt=""
                  src={item.avatar}
                  className="mr-3 icon-profile avatar"
                  height="118"
                  width="118"
                />
              )}
              <span>{item.name ? item.name : 'No username'}</span>
            </td>
            <td className="border-right-5 pr-1 text-right column-score">
              +{item.score}pts
            </td>
          </tr>
        );
      }
      return (
        <tr key={item.id}>
          <th scope="row" className="pr-0 pl-1 row-number">
            {item.position}
          </th>
          <td className="column-name">
            {item.avatar === '' ? (
              <i className="icon-profile avatar mr-3" />
            ) : (
              <img
                alt=""
                src={item.avatar}
                className="mr-3 icon-profile avatar"
                height="118"
                width="118"
              />
            )}
            <span>{item.name ? item.name : 'No username'}</span>
          </td>
          <td className="border-right-5 pr-1 text-right column-score ">
            +{item.score}pts
          </td>
        </tr>
      );
    });
    return scoreList;
  };

  emptyList = () => (
    <div className="empty-list mb-2">
      No activity to display. No one in your AFSC has logged points lately.
    </div>
  );

  render() {
    return (
      <div>
        {this.props.loading && (
          <div className="loading-leaderboard-container">
            <CircularLoading
              height="118"
              width="118"
              className="loading-leaderboard-gif"
            />
          </div>
        )}
        {!this.props.loading &&
        this.props.scoreList &&
        this.props.scoreList.length > 0 ? (
          <table className="table score-table mb-0">
            <tbody>
              {this.props.scoreList.length > 0 && this.loadScoreList()}
            </tbody>
          </table>
        ) : null}
        {!this.props.loading &&
        this.props.scoreList &&
        this.props.scoreList.length === 0 ? (
          <div className="table score-table mb-0">{this.emptyList()}</div>
        ) : null}
        {!this.props.loading && !this.props.scoreList ? (
          <div className="empty-list mb-2">
            Error displaying the leaderboard. Please try again later.
          </div>
        ) : null}
      </div>
    );
  }
}

export default ScoreList;
